import { Reveal } from "@/components/Reveal";
import { BRANDS } from "@/data/site";

const BrandsGrid = ({ label }) => (
  <div className="mt-20" data-testid="brands-grid">
    <Reveal>
      <div className="mb-8 flex items-center gap-4">
        <h3 className="font-display text-lg font-bold text-forest sm:text-xl">{label}</h3>
        <span className="h-px flex-1 bg-gradient-to-r from-brand/60 to-transparent" />
      </div>
    </Reveal>
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-4 lg:grid-cols-5 xl:grid-cols-10">
      {BRANDS.map((b, i) => (
        <Reveal key={b.name} delay={i * 0.03}>
          <div
            data-testid={`brand-card-${i}`}
            className="group flex h-full flex-col items-center gap-3 rounded-2xl border border-brand/10 bg-white px-3 py-5 transition-all duration-500 hover:-translate-y-1 hover:border-gold/40 hover:shadow-xl hover:shadow-gold/10"
          >
            <img
              src={b.logo}
              alt={b.name}
              loading="lazy"
              className="h-10 w-10 object-contain transition-transform duration-500 group-hover:scale-110"
            />
            <span className="font-display text-center text-[11px] font-bold leading-tight text-forest">{b.name}</span>
          </div>
        </Reveal>
      ))}
    </div>
  </div>
);

export default BrandsGrid;
